import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    Autocomplete,
    Stack,
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Backdrop,
    CircularProgress,
    Paper,

} from '@mui/material';
//buttons from mui 4
import { Button, Tooltip, IconButton } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'src/utils/axios';
import ServiceInformationSkeleton from 'src/components/skeleton/ServiceInformationSkeleton';
import SubCard from 'src/components/cards/SubCard';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { confirmAlert } from 'react-confirm-alert';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PrintIcon from '@mui/icons-material/Print';
import { DialogTitle } from '@material-ui/core';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import { Snackbar } from '@material-ui/core';
import Alert from 'src/components/Alert';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import trLocale from 'date-fns/locale/tr';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import ImageCrop from 'src/components/ImageCrop/ImageCrop';
import { set } from 'date-fns';


const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    },
    rootlist: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    },
    rootlistsag: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    },

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: {
        margin: theme.spacing(1),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1500,
        color: '#fff',
    },
    actionsCCFile: {
        justifyContent: 'flex-end'
    }
}));

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
//only turkish uppercase letters and numbers regex
const turkishLowerCaseLetterAndNumberRegexTEST = /^[A-ZÇĞİÖŞÜ0-9]+$/;

//only turkish letter and number regex
const turkishUpperCaseLetterAndNumberRegex = /^[A-Za-zÇçĞğİıÖöŞşÜü0-9]+$/;

//only numbers
const onlyNumbers = /^[0-9]+$/;


const defaultCrop = {
    unit: '%', // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 50,
    height: 50
};



const ServiceVehicles = ({ ServiceShopId, ServiceShopFullName }) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [photoLoading, setPhotoLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertType, setAlertType] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const currentYear = new Date().getFullYear();

    const [serviceVehiclesData, setServiceVehiclesData] = useState([]);
    const [serviceVehiclesBrandCategories, setServiceVehiclesBrandCategories] = useState([]);
    const [serviceFuelTypeCategories, setServiceFuelTypeCategories] = useState([]);
    const [serviceOwnerShipTypeCategories, setServiceOwnerShipTypeCategories] = useState([]);
    const [serviceVehicleTypeCategories, setServiceVehicleTypeCategories] = useState([]);
    const [editableVehicleId, setEditableVehicleId] = useState(0);
    const [addVehiclePopupOpen, setAddVehiclePopupOpen] = useState(false);
    const [vehiclePhotoPopupOpen, setVehiclePhotoPopupOpen] = useState(false);
    const [selectedPhotoVehicleId, setSelectedPhotoVehicleId] = useState(0);
    const [selectedPhotoType, setSelectedPhotoType] = useState(0); // 1: Photo1, 2: Photo2
    const [vehiclePhoto, setVehiclePhoto] = useState(null);
    const [newVehiclePhoto, setNewVehiclePhoto] = useState(null);
    const [photoEditPopupOpen, setPhotoEditPopupOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [crop, setCrop] = useState(defaultCrop);
    const [croppedImageUrl1, setCroppedImageUrl1] = useState(null);
    const [croppedImageUrl2, setCroppedImageUrl2] = useState(null);
    const [croppedImageType, setCroppedImageType] = useState(0);
    const [newAddedPhoto, setNewAddedPhoto] = useState(null);
    const [imageCropDialog, setImageCropDialog] = React.useState(false);

    const [photoEditClick, setPhotoEditClick] = useState(false);
    const [addNewPhotoClick, setAddNewPhotoClick] = useState(false);
    const [addNewPhotoError, setAddNewPhotoError] = useState(false);


    //update stateleri

    const [updatedLicensePlate, setUpdatedLicensePlate] = useState('');
    const [updatedModel, setUpdatedModel] = useState('');
    const [updatedFuelType, setUpdatedFuelType] = useState('');
    const [updatedChasisNumber, setUpdatedChasisNumber] = useState('');
    const [updatedOwnerShipNumber, setUpdatedOwnerShipNumber] = useState('');
    const [updatedBrand, setUpdatedBrand] = useState('');
    const [updatedNewPhoto, setUpdatedNewPhoto] = useState('');
    const [updatedVehicleType, setUpdatedVehicleType] = useState('');


    //add stateleri
    const [newLicensePlate, setNewLicensePlate] = useState('');
    const [newModel, setNewModel] = useState('');
    const [newFuelType, setNewFuelType] = useState('');
    const [newVehicleType, setNewVehicleType] = useState('');
    const [newChasisNumber, setNewChasisNumber] = useState('');
    const [newOwnerShipNumber, setNewOwnerShipNumber] = useState('');
    const [newBrand, setNewBrand] = useState('');
    const [newPhoto1, setNewPhoto1] = useState('');
    const [newPhoto2, setNewPhoto2] = useState('');


    //add error stateleri
    const [newLicensePlateErrorText, setNewLicensePlateErrorText] = useState('');
    const [newModelErrorText, setNewModelErrorText] = useState('');
    const [newFuelTypeErrorText, setNewFuelTypeErrorText] = useState('');
    const [newVehicleTypeErrorText, setNewVehicleTypeErrorText] = useState('');
    const [newChasisNumberErrorText, setNewChasisNumberErrorText] = useState('');
    const [newOwnerShipNumberErrorText, setNewOwnerShipNumberErrorText] = useState('');
    const [newBrandErrorText, setNewBrandErrorText] = useState('');
    const [newPhoto1ErrorText, setNewPhoto1ErrorText] = useState('');
    const [newPhoto2ErrorText, setNewPhoto2ErrorText] = useState('');



    useEffect(() => {
        getServiceVehiclesData();
        getServiceVehiclesCategories();
    }, []);

    const closeAlert = () => {
        setAlert(false);
    }

    const getServiceVehiclesData = () => {
        setLoading(true);
        axios.get('GetServiceVehiclesData/' + ServiceShopId)
            .then((response) => {
                setServiceVehiclesData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }

    const getServiceVehiclesCategories = () => {
        setLoading(true);
        axios.get('GetServiceVehiclesCategories')
            .then((response) => {
                setServiceVehiclesBrandCategories(response.data.BrandType);
                setServiceFuelTypeCategories(response.data.FuelType);
                setServiceOwnerShipTypeCategories(response.data.OwnerShipType);
                setServiceVehicleTypeCategories(response.data.VehicleType);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }



    const handleEditButtonClick = (row) => {
        setEditableVehicleId(row.Id);
        setUpdatedLicensePlate(row.LicensePlate);
        setUpdatedModel(new Date(row.Model, 0, 1));
        setUpdatedFuelType(serviceFuelTypeCategories.find(x => x.Id == row.FuelTypeId));
        setUpdatedVehicleType(serviceVehicleTypeCategories.find(x => x.Id == row.VehicleTypeId));
        setUpdatedChasisNumber(row.ChasisNumber);
        setUpdatedOwnerShipNumber(serviceOwnerShipTypeCategories.find(x => x.Id == row.OwnerShipTypeId));
        setUpdatedBrand(serviceVehiclesBrandCategories.find(x => x.Id == row.BrandId));
    }

    const handleDeleteButtonClick = (Id) => {
        confirmAlert({
            message: 'Seçili aracı silmek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        handleDeleteConfirm(Id);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        console.log('Hayır');
                    }
                }
            ]
        });
    }
    const handleSaveButtonClick = () => {
        confirmAlert({
            message: 'Değişiklikleri kaydetmek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        handleSaveConfirm();
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                    }
                }
            ]
        });
    }

    const handleSaveConfirm = () => {
        if (!updatedLicensePlate) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Plaka boş olamaz');
            return;
        }
        if (!turkishLowerCaseLetterAndNumberRegexTEST.test(updatedLicensePlate)) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Plaka sadece büyük harf ve rakam içerebilir');
            return;
        }
        if (!updatedModel) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Model boş olamaz');
            return;
        }
        if (!updatedVehicleType || !updatedVehicleType.Id) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Araç Tipi boş olamaz');
            return;
        }
        if (!updatedFuelType || !updatedFuelType.Id) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Yakıt Türü boş olamaz');
            return;
        }
        if (!updatedChasisNumber) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Şase No boş olamaz');
            return;
        }
        if (updatedChasisNumber.length != 17) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Şase No 17 karakter olmalıdır');
            return;
        }
        if (!turkishLowerCaseLetterAndNumberRegexTEST.test(updatedChasisNumber)) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Şase No sadece büyük harf ve rakam içerebilir');
            return;
        }
        if (!updatedOwnerShipNumber || !updatedOwnerShipNumber.Id) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Sahiplik Bilgisi boş olamaz');
            return;
        }
        if (!updatedBrand || !updatedBrand.Id) {
            setAlert(true);
            setAlertType('error');
            setAlertMessage('Marka boş olamaz');
            return;
        }



        const data = {
            Id: editableVehicleId,
            ServiceShopId: ServiceShopId,
            LicencePlate: updatedLicensePlate,
            FuelTypeId: updatedFuelType.Id,
            VehicleTypeId: updatedVehicleType.Id,
            ChasisNumber: updatedChasisNumber,
            OwnerShipTypeId: updatedOwnerShipNumber.Id,
            Model: updatedModel.getFullYear(),
            BrandId: updatedBrand.Id,
            Brand: updatedBrand.Dsc,
            Type: 2,
            Photo1: '',
            Photo2: ''
        }


        setLoading(true);
        axios.post('SetServiceVehicle', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlert(true);
                    setAlertType('success');
                    setAlertMessage('Değişiklikler kaydedildi');
                }
                else {
                    setAlert(true);
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                }
                setEditableVehicleId(0);
                getServiceVehiclesData();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Değişiklikler kaydedilirken bir hata oluştu');
            }
            );


    }
    const handleCancelButtonClick = () => {
        setEditableVehicleId(0);
    }

    const handleDeleteConfirm = (Id) => {
        const data = {
            Id: Id,
            ServiceShopId: ServiceShopId,
            LicencePlate: '',
            FuelTypeId: 0,
            VehicleTypeId: 0,
            ChasisNumber: '',
            OwnerShipTypeId: 0,
            Model: '',
            BrandId: 0,
            Brand: '',
            Type: 3,
            Photo1: '',
            Photo2: ''
        }
        setLoading(true);
        axios.post('SetServiceVehicle', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlert(true);
                    setAlertType('success');
                    setAlertMessage('Araç silme işlemi başarılı');
                }
                else {
                    setAlert(true);
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                }
                setEditableVehicleId(0);
                getServiceVehiclesData();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Araç silme işlemi sırasında bir hata oluştu');
            }
            );
    }


    const handleAddVehicleClick = () => {
        confirmAlert({
            message: 'Yeni araç eklemek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        handleAddVehicleConfirm();
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {

                    }
                }
            ]
        });
    }

    const handleAddVehicleConfirm = async () => {
        clearErrorTexts();
        var errorState = false;
        if (!newLicensePlate) {
            setNewLicensePlateErrorText('Plaka boş olamaz');
            errorState = true;
        }
        if (!turkishLowerCaseLetterAndNumberRegexTEST.test(newLicensePlate)) {
            setNewLicensePlateErrorText('Plaka sadece büyük harf ve rakam içerebilir');
            errorState = true;
        }
        if (!newModel) {
            setNewModelErrorText('Model boş olamaz');
            errorState = true;
        }
        if (!newVehicleType || !newVehicleType.Id) {
            setNewVehicleTypeErrorText('Araç Tipi boş olamaz');
            errorState = true;
        }
        if (!newFuelType || !newFuelType.Id) {
            setNewFuelTypeErrorText('Yakıt Türü boş olamaz');
            errorState = true;
        }
        if (!newChasisNumber) {
            setNewChasisNumberErrorText('Şase No boş olamaz');
            errorState = true;
        }
        if (newChasisNumber.length != 17) {
            setNewChasisNumberErrorText('Şase No 17 karakter olmalıdır');
            errorState = true;
        }
        if (!turkishLowerCaseLetterAndNumberRegexTEST.test(newChasisNumber)) {
            setNewChasisNumberErrorText('Şase No sadece büyük harf ve rakam içerebilir');
            errorState = true;
        }

        if (!newOwnerShipNumber || !newOwnerShipNumber.Id) {
            setNewOwnerShipNumberErrorText('Sahiplik Bilgisi boş olamaz');
            errorState = true;
        }
        if (!newBrand || !newBrand.Id) {
            setNewBrandErrorText('Marka boş olamaz');
            errorState = true;
        }
        if (!newPhoto1) {
            setNewPhoto1ErrorText('Foto 1 boş olamaz');
            errorState = true;
        }
        if (!newPhoto2) {
            setNewPhoto2ErrorText('Foto 2 boş olamaz');
            errorState = true;
        }

        if (errorState) {
            return;
        }


        const base64Photo1 = croppedImageUrl1 ? await convertBlobUrlToBase64(croppedImageUrl1) : await convertToBase64(newPhoto1);
        const base64Photo2 = croppedImageUrl2 ? await convertBlobUrlToBase64(croppedImageUrl2) : await convertToBase64(newPhoto2);

        const data = {
            Id: 0,
            ServiceShopId: ServiceShopId,
            LicencePlate: newLicensePlate,
            FuelTypeId: newFuelType.Id,
            VehicleTypeId: newVehicleType.Id,
            ChasisNumber: newChasisNumber,
            OwnerShipTypeId: newOwnerShipNumber.Id,
            Model: newModel.getFullYear(),
            BrandId: newBrand.Id,
            Brand: newBrand.Dsc,
            Type: 1,
            Photo1: base64Photo1,
            Photo2: base64Photo2
        }
        setLoading(true);
        axios.post('SetServiceVehicle', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlert(true);
                    setAlertType('success');
                    setAlertMessage('Araç ekleme işlemi başarılı');
                }
                else {
                    setAlert(true);
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                }
                setAddVehiclePopupOpen(false);
                getServiceVehiclesData();
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setAddVehiclePopupOpen(false);
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Araç ekleme işlemi sırasında bir hata oluştu');
            }
            );
    }

    const handleAddVehiclePopUpClick = () => {
        setNewLicensePlate('');
        setNewModel('');
        setNewFuelType({});
        setNewVehicleType({});
        setNewChasisNumber('');
        setNewOwnerShipNumber({});
        setNewBrand({});
        setNewPhoto1('');
        setNewPhoto2('');
        setCroppedImageUrl1(null);
        setCroppedImageUrl2(null);
        setNewLicensePlateErrorText('');
        setNewModelErrorText('');
        setNewFuelTypeErrorText('');
        setNewChasisNumberErrorText('');
        setNewOwnerShipNumberErrorText('');
        setNewBrandErrorText('');
        setNewPhoto1ErrorText('');
        setNewPhoto2ErrorText('');
        setAddVehiclePopupOpen(true);
    }

    const handleVehiclePhotoPopUpClick = (Id, Type) => {
        setAddNewPhotoClick(false);
        setNewAddedPhoto(null);
        setNewVehiclePhoto(null);
        setSelectedPhotoVehicleId(Id);
        setSelectedPhotoType(Type);
        getVehiclePhoto(Id, Type);
        setVehiclePhotoPopupOpen(true);
        setPhotoEditClick(false);
    }

    const getVehiclePhoto = (Id, Type) => {
        setPhotoLoading(true);
        axios.get('GetServiceVehiclePhoto/' + Id + '/' + Type)
            .then((response) => {
                if (!response) {
                    setVehiclePhoto(null);
                    setNewAddedPhoto(null);
                }
                else {
                    setVehiclePhoto(`data:image/jpeg;base64,${response.data}`);
                }
                setPhotoLoading(false);
            })
            .catch((error) => {
                setVehiclePhoto(null);
                setNewAddedPhoto(null);
                setPhotoLoading(false);
            }
            );
    }

    const handlePhotoEditButtonClick = (photo, type) => {
        console.log(photo);
        setCroppedImageType(type);
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            setSelectedImage(reader.result);
            setPhotoEditPopupOpen(true);
            setImageCropDialog(true);
        });
        reader.readAsDataURL(photo);
        setCrop(defaultCrop);
    }

    const handleCropComplete = () => {
        getCroppedImg();
        setPhotoEditPopupOpen(false);
    };

    const getCroppedImg = () => {
        const image = document.createElement('img');
        image.src = selectedImage;

        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        if (croppedImageType === 1) {
            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Canvas is empty');
                        return;
                    }
                    blob.name = newPhoto1.name;
                    window.URL.revokeObjectURL(croppedImageUrl1);
                    setCroppedImageUrl1(window.URL.createObjectURL(blob));
                    resolve(croppedImageUrl1);
                }, 'image/jpeg');
            });
        }
        else {
            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Canvas is empty');
                        return;
                    }
                    blob.name = newPhoto2.name;
                    window.URL.revokeObjectURL(croppedImageUrl2);
                    setCroppedImageUrl2(window.URL.createObjectURL(blob));
                    resolve(croppedImageUrl2);
                }, 'image/jpeg');
            });
        }

    }

    const getCroppedImgAdd = () => {
        const image = document.createElement('img');
        image.src = vehiclePhoto;

        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error('Canvas is empty');
                    return;
                }

                window.URL.revokeObjectURL(newVehiclePhoto);
                updateServicePhoto(selectedPhotoVehicleId, selectedPhotoType, window.URL.createObjectURL(blob));
                setPhotoEditClick(false);
                resolve(newVehiclePhoto);
            }, 'image/jpeg');
        })
    }

    const clearErrorTexts = () => {
        setNewLicensePlateErrorText('');
        setNewModelErrorText('');
        setNewVehicleTypeErrorText('');
        setNewFuelTypeErrorText('');
        setNewChasisNumberErrorText('');
        setNewOwnerShipNumberErrorText('');
        setNewBrandErrorText('');
        setNewPhoto1ErrorText('');
        setNewPhoto2ErrorText('');
    }


    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result;
                // Base64 string'in data kısmını alma
                const base64Data = base64String.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = error => reject(error);
        });
    };

    const convertBlobUrlToBase64 = async (blobUrl) => {
        const response = await fetch(blobUrl);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64String = reader.result;
                const base64Data = base64String.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = error => reject(error);
        });
    };

    const updateServicePhoto = async (Id, Type, Photo) => {

        const base64Photo = await convertBlobUrlToBase64(Photo);

        const data = {
            Id: Id,
            Type: Type,
            NewPhoto: base64Photo
        }
        setLoading(true);
        axios.post('SetServiceVehiclePhoto', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlert(true);
                    setAlertType('success');
                    setAlertMessage('Fotoğraf güncelleme işlemi başarılı');
                    setVehiclePhotoPopupOpen(false);
                    setImageCropDialog(false);
                }
                else {
                    setAlert(true);
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                    setVehiclePhotoPopupOpen(false);
                    setImageCropDialog(false);
                }
                getVehiclePhoto(Id, Type);
                setLoading(false);
            })
            .catch((error) => {
                setVehiclePhotoPopupOpen(false);
                setLoading(false);
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Fotoğraf güncelleme işlemi sırasında bir hata oluştu');
                setImageCropDialog(false);
            }
            );
    }

    const onImageLoaded = (image) => {
        setSelectedImage(image);
    };

    const AddServiceNewPhoto = async () => {
        setAddNewPhotoError(false);
        if (!newAddedPhoto) {
            setAddNewPhotoError(true);
            return;
        }

        const base64Photo = await convertToBase64(newAddedPhoto);
        console.log(base64Photo);
        console.log(newAddedPhoto);

        const data = {
            Id: selectedPhotoVehicleId,
            Type: selectedPhotoType,
            NewPhoto: base64Photo
        }
        setLoading(true);
        axios.post('SetServiceVehiclePhoto', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlert(true);
                    setAlertType('success');
                    setAlertMessage('Fotoğraf ekleme işlemi başarılı');
                    setVehiclePhotoPopupOpen(false);
                }
                else {
                    setAlert(true);
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                    setVehiclePhotoPopupOpen(false);
                }
                getVehiclePhoto(selectedPhotoVehicleId, selectedPhotoType);
                setLoading(false);
            })
            .catch((error) => {
                setVehiclePhotoPopupOpen(false);
                setLoading(false);
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Fotoğraf ekleme işlemi sırasında bir hata oluştu');
            }
            );
    }


    const handleOpenImage = (photo) => {

        let image = new Image();
        image.src = photo;
        var newTab = window.open();
        newTab.document.body.innerHTML = image.outerHTML;
    };


    const handleImageCropDialogClose = () => {
        setImageCropDialog(false);
        setPhotoEditPopupOpen(false);
        setPhotoEditClick(false);
    }

    const handleImageCropComplete = (photo) => {
        confirmAlert({
            message: 'Fotoğrafı güncellemek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        updateServicePhoto(selectedPhotoVehicleId, selectedPhotoType, photo);
                        setVehiclePhotoPopupOpen(false);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        handleImageCropDialogClose();
                    }
                }
            ]
        });
    }

    function capitalizeTurkish(text) {
        // Türkçe karakterleri düzgün işlemek için kullanılacak karakter eşlemeleri
        const turkishMapping = {
            'ğ': 'Ğ',
            'ü': 'Ü',
            'ş': 'Ş',
            'ı': 'I',
            'i': 'İ',
            'ö': 'Ö',
            'ç': 'Ç',
            'Ğ': 'Ğ',
            'Ü': 'Ü',
            'Ş': 'Ş',
            'I': 'I',
            'İ': 'İ',
            'Ö': 'Ö',
            'Ç': 'Ç'
        };

        return text.split(' ').map(word => {
            // İlk harfi büyük, geri kalan harfleri küçük yap
            let firstChar = word.charAt(0);
            let restOfWord = word.slice(1).toLowerCase();

            // İlk harfi kontrol et ve eşleşen bir Türkçe karakter varsa onu kullan
            if (turkishMapping[firstChar.toLowerCase()]) {
                firstChar = turkishMapping[firstChar.toLowerCase()];
            } else {
                firstChar = firstChar.toUpperCase();
            }

            return firstChar + restOfWord;
        }).join(' ');
    }

    const Base64Button = ({ row, type }) => {
        const base64ImageString = 'data:image/png;base64,' + (type == 1 ? row.Photo1Img : row.Photo2Img);
        return (
            <Button
                variant="outlined"
                onClick={() => {
                    if (row.Photo1 == 1) {
                        setAddNewPhotoClick(true);
                    }
                    handleVehiclePhotoPopUpClick(row.Id, type)
                }}
                style={{
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    borderColor: "#FF9800",
                    borderWidth: 2,
                }}
            >
                <img
                    src={base64ImageString}
                    style={{ height: "60px", width: "90px", objectFit: "cover" }}
                    loading='lazy'
                />
                <span
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "5px", // Daha fazla boşluk için arttırıldı
                        borderRadius: "50%",
                        margin: "2px", // İkon etrafında boşluk için
                    }}
                >
                    {/* <EditIcon style={{ fontSize: '30px' }} /> */}
                    <IconButton size="small" style={{ color: '#eeeeee' }}>
                        <EditIcon style={{ fontSize: '20px' }} />
                    </IconButton>
                </span>
            </Button>
        );
    };




    return (
        <Grid container spacing={3} >
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={alert} autoHideDuration={10000} onClose={closeAlert}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={closeAlert} variant={alertType} message={alertMessage}>
                </Alert>
            </Snackbar>
            <Grid item xs={12} md={12} lg={12}>
                <SubCard title={
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={6} md={6} lg={6} justifyContent="center" alignItems="center">
                            {ServiceShopFullName}
                        </Grid>
                        <Grid item xs={6} md={6} lg={6}>
                            <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        handleAddVehiclePopUpClick(true);
                                    }}
                                >
                                    Ekle
                                    <AddCircleIcon style={{ marginLeft: '5px' }} />
                                </Button>
                                {/* <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        handleExportClick();
                                    }}
                                    style={{ marginRight: '5px' }} // Add margin to the right
                                >
                                    YAZDIR
                                    <PrintIcon style={{ marginLeft: '5px' }} />
                                </Button> */}
                            </Stack>
                        </Grid>
                    </Grid>
                }>
                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer >
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>PLAKA</TableCell>
                                        <TableCell>MODEL</TableCell>
                                        <TableCell>ARAÇ TİPİ</TableCell>
                                        <TableCell>YAKIT TÜRÜ</TableCell>
                                        <TableCell>ŞASE NO</TableCell>
                                        <TableCell>SAHİPLİK BİLGİSİ</TableCell>
                                        <TableCell>MARKA</TableCell>
                                        <TableCell>FOTOĞRAF 1</TableCell>
                                        <TableCell>FOTOĞRAF 2</TableCell>
                                        <TableCell>İŞLEM</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {serviceVehiclesData.length > 0 && serviceVehiclesData?.map((row) => (
                                        <TableRow key={row.Id}>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <TextField
                                                        variant="outlined"
                                                        type="text"
                                                        size='small'
                                                        value={updatedLicensePlate}
                                                        onChange={(e) => setUpdatedLicensePlate(e.target.value)}
                                                    />
                                                ) : (
                                                    row.LicensePlate
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    // <TextField
                                                    //     variant="outlined"
                                                    //     type="tel"
                                                    //     size='small'
                                                    //     value={updatedModel}
                                                    //     onChange={(e) => setUpdatedModel(e.target.value)}
                                                    // />

                                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                                                        <DatePicker
                                                            views={['year']}
                                                            value={updatedModel}
                                                            minDate={new Date(1988, 1, 1)}
                                                            maxDate={new Date(currentYear, 11, 31)}
                                                            onChange={(newValue) => {
                                                                setUpdatedModel(newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    size='small'
                                                                />
                                                            )}
                                                            slotProps={{ textField: { size: 'small' } }}
                                                        />
                                                    </LocalizationProvider>
                                                ) : (
                                                    row.Model
                                                )}

                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={serviceVehicleTypeCategories}
                                                        getOptionLabel={(option) => capitalizeTurkish(option.Dsc)}
                                                        style={{ width: 200 }}
                                                        renderInput={(params) => <TextField {...params} size='small' variant="outlined" />}
                                                        value={updatedVehicleType}
                                                        onChange={(event, newValue) => {
                                                            setUpdatedVehicleType(newValue);
                                                        }}
                                                    />
                                                ) : (
                                                    capitalizeTurkish(row.VehicleType)
                                                )}

                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={serviceFuelTypeCategories}
                                                        getOptionLabel={(option) => option.Dsc}
                                                        style={{ width: 200 }}
                                                        renderInput={(params) => <TextField {...params} size='small' variant="outlined" />}
                                                        value={updatedFuelType}
                                                        onChange={(event, newValue) => {
                                                            setUpdatedFuelType(newValue);
                                                        }}
                                                    />
                                                ) : (
                                                    row.FuelType
                                                )}

                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <TextField
                                                        variant="outlined"
                                                        type="text"
                                                        size='small'
                                                        value={updatedChasisNumber}
                                                        onChange={(e) => setUpdatedChasisNumber(e.target.value)}
                                                    />
                                                ) : (
                                                    row.ChasisNumber
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={serviceOwnerShipTypeCategories}
                                                        getOptionLabel={(option) => option.Dsc}
                                                        style={{ width: 200 }}
                                                        renderInput={(params) => <TextField {...params} size='small' variant="outlined" />}
                                                        value={updatedOwnerShipNumber}
                                                        onChange={(event, newValue) => {
                                                            setUpdatedOwnerShipNumber(newValue);
                                                        }}
                                                    />
                                                ) : (
                                                    row.OwnerShipType
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {editableVehicleId == row.Id ? (
                                                    <Autocomplete
                                                        id="combo-box-demo"
                                                        options={serviceVehiclesBrandCategories}
                                                        getOptionLabel={(option) => option.Dsc}
                                                        style={{ width: 200 }}
                                                        renderInput={(params) => <TextField {...params} size='small' variant="outlined" />}
                                                        value={updatedBrand}
                                                        onChange={(event, newValue) => {
                                                            setUpdatedBrand(newValue);
                                                        }}
                                                    />
                                                ) : (
                                                    row.Brand
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {row.Photo1 == 1 ? (
                                                    <Base64Button row={row} type={1} />
                                                ) : (
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.button}
                                                        onClick={() => {
                                                            if (row.Photo1 == 1) {
                                                                setAddNewPhotoClick(true);
                                                            }
                                                            handleVehiclePhotoPopUpClick(row.Id, 1)
                                                        }}
                                                        style={{ textTransform: 'none' }}
                                                    >
                                                        Fotoğraf 1
                                                    </Button>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {row.Photo2 == 1 ? (
                                                    <Base64Button row={row} type={2} />
                                                ) : (
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.button}
                                                        onClick={() => {
                                                            if (row.Photo2 == 1) {
                                                                setAddNewPhotoClick(true);
                                                            }
                                                            handleVehiclePhotoPopUpClick(row.Id, 2)
                                                        }}
                                                        style={{ textTransform: 'none' }}
                                                    >
                                                        Fotoğraf 2
                                                    </Button>
                                                )}
                                            </TableCell>
                                            <TableCell >
                                                <div style={{ width: '100px' }}>
                                                    {editableVehicleId == row.Id ?
                                                        <>
                                                            <Tooltip title="Kaydet">
                                                                <IconButton
                                                                    size="large"
                                                                    onClick={() => handleSaveButtonClick()}
                                                                >
                                                                    <SaveIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="İptal">
                                                                <IconButton
                                                                    size="large"
                                                                    onClick={() => handleCancelButtonClick()}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                        :
                                                        <>
                                                            <Tooltip title="Düzenle">
                                                                <IconButton
                                                                    size="large"
                                                                    onClick={() => handleEditButtonClick(row)}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Sil">
                                                                <IconButton
                                                                    size="large"
                                                                    onClick={() => handleDeleteButtonClick(row.Id)}
                                                                >
                                                                    <DeleteForeverIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    }


                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </SubCard>
            </Grid>
            <Dialog
                open={addVehiclePopupOpen}
                onClose={() => {
                    setAddVehiclePopupOpen(false);
                }}
            >
                <DialogTitle>
                    Araç Ekle
                </DialogTitle>
                <DialogContent style={{ paddingTop: 6 }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                variant="outlined"
                                type="text"
                                label='Plaka'
                                error={newLicensePlateErrorText ? true : false}
                                helperText={newLicensePlateErrorText}
                                value={newLicensePlate}
                                onChange={(e) => setNewLicensePlate(e.target.value)}
                                onKeyDown={(e) => {
                                    if (!turkishUpperCaseLetterAndNumberRegex.test(e.key) && e.key !== 'Backspace') {
                                        e.preventDefault();
                                    }
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
                                <DatePicker
                                    views={['year']}
                                    label="Model (YIL)"
                                    value={newModel}
                                    minDate={new Date(1988, 1, 1)}
                                    maxDate={new Date(currentYear, 11, 31)}
                                    onChange={(newValue) => {
                                        setNewModel(newValue);
                                        setNewModelErrorText('');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            error={newModelErrorText ? true : false}
                                            helperText={newModelErrorText}

                                            fullWidth
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            required: true,
                                            error: !!newModelErrorText,
                                            helperText: newModelErrorText
                                        }
                                    }}

                                />
                            </LocalizationProvider>

                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={serviceVehicleTypeCategories}
                                getOptionLabel={(option) => capitalizeTurkish(option.Dsc || '')}

                                renderInput={(params) => <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Araç Tipi"
                                    error={newVehicleTypeErrorText ? true : false}
                                    helperText={newVehicleTypeErrorText}
                                />}
                                value={newVehicleType}
                                onChange={(event, newValue) => {
                                    setNewVehicleType(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={serviceFuelTypeCategories}
                                getOptionLabel={(option) => option.Dsc || ''}

                                renderInput={(params) => <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Yakıt Türü"
                                    error={newFuelTypeErrorText ? true : false}
                                    helperText={newFuelTypeErrorText}
                                />}
                                value={newFuelType}
                                onChange={(event, newValue) => {
                                    setNewFuelType(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <TextField
                                variant="outlined"
                                type="text"
                                label='Şase No'
                                error={newChasisNumberErrorText ? true : false}
                                helperText={newChasisNumberErrorText}
                                value={newChasisNumber}
                                onChange={(e) => setNewChasisNumber(e.target.value)}
                                onAbort={(e) => {
                                    if (!turkishUpperCaseLetterAndNumberRegex.test(e.key) && e.key !== 'Backspace') {
                                        e.preventDefault();
                                    }
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={serviceOwnerShipTypeCategories}
                                getOptionLabel={(option) => option.Dsc || ''}
                                renderInput={(params) => <TextField {...params}
                                    variant="outlined"
                                    label="Sahiplik Bilgisi"
                                    error={newOwnerShipNumberErrorText ? true : false}
                                    helperText={newOwnerShipNumberErrorText}
                                />}
                                value={newOwnerShipNumber}
                                onChange={(event, newValue) => {
                                    setNewOwnerShipNumber(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={serviceVehiclesBrandCategories}
                                getOptionLabel={(option) => option.Dsc || ''}
                                renderInput={(params) => <TextField {...params}
                                    variant="outlined"
                                    label="Marka"
                                    error={newBrandErrorText ? true : false}
                                    helperText={newBrandErrorText}
                                />}
                                value={newBrand}
                                onChange={(event, newValue) => {
                                    setNewBrand(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={6} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Stack direction="column" spacing={1} alignItems="center">
                                <Button
                                    component="label"
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Foto 1
                                    <VisuallyHiddenInput
                                        type="file"
                                        accept='image/*'
                                        onChange={(e) => {
                                            setCroppedImageUrl1(null);
                                            setNewPhoto1(e.target.files[0]);
                                        }}
                                    />
                                </Button>
                                {newPhoto1ErrorText ? (
                                    <Typography style={{
                                        color: 'red',
                                        marginTop: 5
                                    }}>
                                        {newPhoto1ErrorText}
                                    </Typography>
                                ) : null}
                                {croppedImageUrl1 ? (
                                    <>
                                        <img
                                            src={croppedImageUrl1}
                                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                                        />
                                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                            {newPhoto1.name}
                                        </Typography>
                                        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                            <IconButton
                                                onClick={
                                                    () => handlePhotoEditButtonClick(newPhoto1, 1)
                                                }
                                                size="small"
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={
                                                    () => {
                                                        setNewPhoto1('');
                                                        setCroppedImageUrl1(null);
                                                    }
                                                }
                                                size="small"
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </Stack>
                                    </>
                                ) :
                                    newPhoto1 ? (
                                        <>
                                            <img
                                                src={URL.createObjectURL(newPhoto1)}
                                                style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            />

                                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                {newPhoto1.name}
                                            </Typography>
                                            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                                <IconButton
                                                    onClick={
                                                        () => handlePhotoEditButtonClick(newPhoto1, 1)
                                                    }
                                                    size="small"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={
                                                        () => {
                                                            setNewPhoto1('');
                                                            setCroppedImageUrl1(null);
                                                        }
                                                    }
                                                    size="small"
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Stack>
                                        </>
                                    ) : null}
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Stack direction="column" spacing={1} alignItems="center">
                                <Button
                                    component="label"
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Foto 2
                                    <VisuallyHiddenInput
                                        type="file"
                                        accept='image/*'
                                        onChange={(e) => {
                                            setCroppedImageUrl2(null);
                                            setNewPhoto2(e.target.files[0]);
                                        }}
                                    />
                                </Button>
                                {newPhoto2ErrorText ? (
                                    <Typography style={{
                                        color: 'red',
                                        marginTop: 5
                                    }}>
                                        {newPhoto2ErrorText}
                                    </Typography>
                                ) : null}
                                {croppedImageUrl2 ? (
                                    <>
                                        <img
                                            src={croppedImageUrl2}
                                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                                        />
                                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                            {newPhoto2.name}
                                        </Typography>
                                        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                            <IconButton
                                                onClick={
                                                    () => handlePhotoEditButtonClick(newPhoto2, 2)
                                                }
                                                size="small"
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={
                                                    () => {
                                                        setNewPhoto2('');
                                                        setCroppedImageUrl2(null);
                                                    }
                                                }
                                                size="small"
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </Stack>
                                    </>
                                ) :
                                    newPhoto2 ? (
                                        <>
                                            <img
                                                src={URL.createObjectURL(newPhoto2)}
                                                style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            />

                                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                {newPhoto2.name}
                                            </Typography>
                                            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                                <IconButton
                                                    onClick={
                                                        () => handlePhotoEditButtonClick(newPhoto2, 2)
                                                    }
                                                    size="small"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={
                                                        () => {
                                                            setNewPhoto2('');
                                                            setCroppedImageUrl2(null);
                                                        }
                                                    }
                                                    size="small"
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Stack>
                                        </>
                                    ) : null}
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                onClick={() => {
                                    handleAddVehicleClick();
                                }}
                            >
                                Ekle
                            </Button>
                        </Grid>

                    </Grid>
                </DialogContent>
            </Dialog>
            <Dialog
                open={vehiclePhotoPopupOpen}
                onClose={() => {
                    setVehiclePhotoPopupOpen(false);
                }}
            >
                <DialogTitle
                    size="small"
                    id="responsive-dialog-title"
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>Araç Fotoğrafı</div>
                    <IconButton
                        edge="end"
                        size="small"
                        color="inherit"
                        onClick={() => {
                            setVehiclePhotoPopupOpen(false);
                        }}
                        aria-label="close"

                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12} lg={12} textAlign={'center'}>


                            {addNewPhotoClick ? (
                                <Stack direction="column" spacing={2} alignItems="center">
                                    <Button
                                        component="label"
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<CloudUploadIcon />}
                                    >
                                        Fotoğraf Yükle
                                        <VisuallyHiddenInput
                                            type="file"
                                            accept='image/*'
                                            onChange={(e) => {
                                                setNewAddedPhoto(e.target.files[0]);
                                            }}
                                        />
                                    </Button>
                                    {!newAddedPhoto ? (
                                        <>
                                            <ImageNotSupportedIcon style={{ fontSize: 100, }} />
                                            {addNewPhotoError ?
                                                <MuiAlert severity="error" style={{ marginBottom: 10 }}>
                                                    Lütfen bir fotoğraf seçiniz
                                                </MuiAlert>
                                                : null
                                            }
                                        </>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
                                            <img
                                                src={URL.createObjectURL(newAddedPhoto)}
                                                style={{ maxWidth: '500px', maxHeight: '500px', marginBottom: 10 }}
                                            />
                                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                {newAddedPhoto.name}
                                            </Typography>
                                        </div>
                                    )}
                                </Stack>
                            ) :

                                photoLoading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                                        <CircularProgress />
                                    </div>

                                )
                                    : vehiclePhoto && photoEditClick ? (
                                        <ImageCrop
                                            image={vehiclePhoto}
                                            setNewImage={handleImageCropComplete}
                                            open={imageCropDialog}
                                            handleClose={handleImageCropDialogClose}
                                        />
                                        // <ReactCrop crop={crop} onChange={setCrop} style={{ textAlign: 'center', alignItems: 'center' }} justifyContent="center" alignItems="center">
                                        //     <img src={vehiclePhoto} style={{ maxWidth: '100%' }} />
                                        // </ReactCrop>
                                    ) :
                                        vehiclePhoto ? (
                                            <div style={{
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}>
                                                <img
                                                    src={vehiclePhoto}
                                                    alt={'Araç Fotoğrafı'}
                                                    style={{
                                                        maxWidth: '100%',
                                                        maxHeight: '100%',
                                                        objectFit: 'contain',
                                                    }}
                                                    onClick={() => handleOpenImage(vehiclePhoto)}
                                                />
                                            </div>
                                        ) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                                            <CircularProgress />
                                        </div>}
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
                                {addNewPhotoClick || photoEditClick ?
                                    (<>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                if (addNewPhotoClick) {
                                                    AddServiceNewPhoto();
                                                }
                                                else {
                                                    getCroppedImgAdd();
                                                }
                                            }}
                                        >
                                            KAYDET
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => {
                                                setPhotoEditClick(false);
                                                setAddNewPhotoClick(false);
                                            }}
                                        >
                                            İPTAL
                                        </Button>
                                    </>
                                    ) : (
                                        <>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => {
                                                    setAddNewPhotoClick(true);
                                                }}
                                            >
                                                Yeni Fotoğraf Ekle
                                            </Button>

                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => {
                                                    setCrop(defaultCrop);
                                                    setPhotoEditClick(true);
                                                    setImageCropDialog(true);
                                                }}
                                            >
                                                DÜZENLE
                                            </Button>
                                        </>
                                    )}
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            {photoEditPopupOpen && (
                <ImageCrop
                    image={selectedImage}
                    setNewImage={croppedImageType == 1 ? setCroppedImageUrl1 : setCroppedImageUrl2}
                    open={imageCropDialog}
                    handleClose={handleImageCropDialogClose}
                />
            )
            }
            {/* <Dialog open={photoEditPopupOpen} onClose={() => setPhotoEditPopupOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Fotoğrafı Düzenle</DialogTitle>
                <DialogContent>
                    {selectedImage && (
                        <ReactCrop crop={crop} onChange={setCrop} >
                            <img src={selectedImage} style={{ maxWidth: '100%' }} />
                        </ReactCrop>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPhotoEditPopupOpen(false)} color="secondary">
                        İptal
                    </Button>
                    <Button onClick={handleCropComplete} color="primary">
                        Kaydet
                    </Button>
                </DialogActions>
            </Dialog> */}
        </Grid >
    );
};

export default ServiceVehicles;